import { Box, Container, Grid, Text } from '@chakra-ui/react';
import { Header } from '../../atoms/Header';
import { RevealOnScroll } from '../../atoms/RevealOnScroll';
import { GettingStartedCardAlt } from '../../molecules/CardWithBg';
import { AvailableIcon } from 'src/components/atoms/Icon';

const popularResources = [
  {
    title: 'Getting Started Guide',
    description: (
      <>
        Learn how to begin using the platform
        <br />
        with quick and easy setup steps.
      </>
    ),
    icon: 'graduation-cap',
    href: '/resources/getting-started',
  },
  {
    title: 'Pricing Plans',
    description: (
      <>
        Explore flexible plans that scale with <br /> your team&apos;s growth
        and goals.
      </>
    ),
    icon: 'credit-card',
    href: '/resources/pricing-plans',
  },
  {
    title: 'Invite Your Team',
    description: (
      <>
        Add teammates to collaborate and <br /> boost your workflow instantly.
      </>
    ),
    icon: 'users',
    href: '/resources/invite-your-team',
  },
  {
    title: 'Track Issues',
    description: (
      <>
        Organize tasks, spot blockers, and <br /> monitor project progress
        easily.
      </>
    ),
    icon: 'circle-checkbox',
    href: '/resources/track-issues',
  },
];

const allResources = [
  {
    title: 'Workspace Settings',
    description:
      'Adjust user roles, preferences, and workspace-wide configurations.',
    icon: 'gear',
    href: '/resources/workspace-settings',
  },
  {
    title: 'How Integrations Work',
    description: 'Understand how external tools connect to your workspace.',
    icon: 'puzzle',
    href: '/resources/how-integrations-work',
  },
  {
    title: 'Custom Setup',
    description: 'Tailor advanced features to suit you companies needs.',
    icon: 'filters',
    href: '/resources/custom-setup',
  },
  {
    title: 'FAQ & Support',
    description: 'Get quick answers or reach out to our support team for help.',
    icon: 'document-question',
    href: '/resources/faq-support',
  },
];

const ResourcesPage = () => {
  return (
    <Box color="text.darkBlue.900">
      <Container py={{ base: 8, md: 16 }} maxW="container.xl">
        <Header fontSize="4.5xl">
          Resources & Docs
          <Text
            fontSize="md"
            color="text.darkBlue.800"
            fontFamily="marketingPage"
            fontWeight="normal"
            mt={4}
            mb={{ base: 8, md: 12 }}>
            Documentation and product examples to help you get up and running.
          </Text>
        </Header>
        <RevealOnScroll>
          <Text
            fontFamily="marketingPage"
            fontWeight="bold"
            mb={8}
            fontSize="4xl"
            color="text.darkBlue.900">
            Popular:
          </Text>
          <Grid gap={4} templateColumns="repeat(2, 1fr)">
            {popularResources.map((resource) => (
              <GettingStartedCardAlt
                key={resource.title}
                title={resource.title}
                description={resource.description}
                icon={resource.icon as AvailableIcon}
                href={resource.href}
              />
            ))}
          </Grid>
        </RevealOnScroll>
        <RevealOnScroll>
          <Text
            fontFamily="marketingPage"
            fontWeight="bold"
            my={8}
            fontSize="4xl"
            color="text.darkBlue.900">
            All Docs:
          </Text>
          <Grid gap={4} templateColumns="repeat(2, 1fr)">
            {allResources.map((resource) => (
              <GettingStartedCardAlt
                key={resource.title}
                title={resource.title}
                description={resource.description}
                icon={resource.icon as AvailableIcon}
                href={resource.href}
              />
            ))}
          </Grid>
        </RevealOnScroll>
      </Container>
    </Box>
  );
};

export default ResourcesPage;
